import { ILoanProducts, ICompletedCategory } from "loan-application/interface";

export enum Actions {
    REQUEST_GET_LOAN_PRODUCTS = "REQUEST_GET_LOAN_PRODUCTS",
    SET_LOAN_PRODUCTS = "SET_LOAN_PRODUCTS",
    SET_ELIGIBILITY_INPUT = "SET_ELIGIBILITY_INPUT",
    SET_APPLICATION_FIELDS = "SET_APPLICATION_FIELDS",
    SELECTED_LOAN_PRODUCT = "SELECTED_LOAN_PRODUCT",
    INITIALIZE_CATEGORY = "INITIALIZE_CATEGORY",
    CATEGORY_COMPLETED = "CATEGORY_COMPLETED",
    CLEAR_APPLICATION_FIELDS = "CLEAR_APPLICATION_FIELDS",
    SET_KYC_MODES = "SET_KYC_MODES",
    SET_APPLICATION_INDEX = "SET_APPLICATION_INDEX",
    UPDATE_APPLICATION_FIELDS = "UPDATE_APPLICATION_FIELDS",
}

export function getLoanProducts() {
    return { type: Actions.REQUEST_GET_LOAN_PRODUCTS};
}

export function setEligibilityInput(userInput) {
    return{type: Actions.SET_ELIGIBILITY_INPUT, body: userInput};
}

export function setLoanProducts(products: ILoanProducts[]) {
    return {type: Actions.SET_LOAN_PRODUCTS, body: products};
}

export function setApplicationFields(fields: any) {
    return {type: Actions.SET_APPLICATION_FIELDS, body: fields};
}

export function selectedLoanProduct(productName: string) {
    return {type: Actions.SELECTED_LOAN_PRODUCT, body: productName};
}

export function initCategory(category: ICompletedCategory[]) {
    return {type: Actions.INITIALIZE_CATEGORY, body: category};
}

export function markCategoryComplete(categoryStatus: boolean, index: number) {
    return {type: Actions.CATEGORY_COMPLETED, categoryStatus, index};
}

export function clearApplicationFields() {
    return {type: Actions.CLEAR_APPLICATION_FIELDS};
}

export function setKycModes(kycModes: []) {
    return {type: Actions.SET_KYC_MODES, body: kycModes};
}

export function setApplicationIndex(index: number) {
    return {type: Actions.SET_APPLICATION_INDEX, body: index};
}

export function updateApplicationFieldInfo(index: number, fieldsValue) {
    return {type: Actions.UPDATE_APPLICATION_FIELDS, body: {index, fieldsValue}};
}